// @flow
import React from 'react'
import { validate } from 'devx-js-utilities'
import classNames from 'classnames'

import AbstractFormField from './AbstractFormField'

// types
import type { DefaultFormFieldType } from './AbstractFormField'

type Props = DefaultFormFieldType & {
  id: string,
  tabIndex: string,
  value: string,
  inputType?: string,
  invalidClassName?: string,
  maxLength?: number,
}

const validateField = (value, props) => {
  let error = {}
  if (props.required && (!value || value === null || value === '')) {
    error = {
      error_type: 'REQUIRED',
      item_index: 2
    }
    props.onErrorChange(props.name, error)
    return false
  }
  if (props.type === 'phone' && !validate.validatePhone(value)) {
    error = {
      error_type: 'INVALID_PHONE',
      item_index: 6
    }
    props.onErrorChange(props.name, error)
    return false
  }
  props.onErrorChange(props.name, {})
  return true
}

type State = {
  value: string | number,
  required: boolean,
}

export default class String extends AbstractFormField<Props, State> {
  ref = React.createRef()

  static defaultProps = {
    tabIndex: null,
    inputType: 'text',
    invalidClassName: 'invalid-tooltip mt-0'
  }

  state = {
    value: Infinity
  }


  static getDerivedStateFromProps(nextProps, nextState) {
    if (nextProps.value !== nextState.value && nextState.value !== Infinity && nextProps.required !== nextState.required) {
      validateField(nextProps.value, nextProps)
    }
    return {
      value: nextProps.value,
      required: nextProps.required,
    }
  }

  handleOnChange = (event: { target: { value: string | number } }) => {
    const regex = /^\+?([0-9]{0,12})$/
    if (this.props.inputType === 'tel') {
      if (regex.test(event.target.value)) {
        this.props.onChange(this.props.id, event.target.value)
      }
    } else {
      this.props.onChange(this.props.id, event.target.value)
    }
  }

  handleOnBlur = (event: { target: { value: string | number } }) => {
    this.validate(event.target.value)
    this.props.onBlur(this.props.name, event.target.value)
  }

  validate = (value: string | number) => validateField(value, this.props)

  render() {
    if (this.props.textMode) {
      return <p>{this.props.value}</p>
    }

    return (
      <React.Fragment>
        <input
          className={classNames(this.props.className, this.hasErrors() && !this.isPristine() ? 'is-invalid' : '')}
          data-hj-whitelist
          id={this.props.id}
          key={`${this.props.name}-input`}
          maxLength={this.props.maxLength}
          name={this.props.name}
          onBlur={this.handleOnBlur}
          onChange={this.handleOnChange}
          placeholder={this.props.placeholder}
          readOnly={this.props.readOnly}
          ref={this.ref}
          tabIndex={this.props.tabIndex}
          type={this.props.inputType}
          value={this.props.value || ''}
        />
        {this.hasErrors() && !this.isPristine() &&
        <div className={this.props.invalidClassName}>
          <span>{this.getErrorText()}</span>
        </div>
        }
      </React.Fragment>
    )
  }
}
